<template>
  <div>
    <div
      class="breadcrumb-section jarallax pixels-bg"
      data-jarallax
      data-speed="0.6"
    >
      <div class="container text-center">
        <h1>CONTACTEZ-NOUS</h1>
        <ul>
          <li><a href="/">Accueil</a></li>
          <li><a href="javascript:void(0);">Contactez-nous</a></li>
        </ul>
      </div>
    </div>
    <div class="section-block">
      <div class="container">
        <div class="row" v-if="contacts != null">
          <div class="col-md-4 col-sm-12 col-12">
            <div class="contact-box-info-4">
              <i class="icon-phone-book"></i>
              <h4>{{ contacts[2].name }}</h4>
              <p v-html="contacts[2].description"></p>
              <h5>{{ contacts[2].value }}</h5>
            </div>
          </div>
          <div class="col-md-4 col-sm-12 col-12">
            <div class="contact-box-info-4 contact-box-info-4-center">
              <i
                class="icon-mail-envelope-opened-outlined-interface-symbol"
              ></i>
              <h4>{{ contacts[0].name }}</h4>
              <p v-html="contacts[0].description"></p>
              <h5>{{ contacts[0].value }}</h5>
            </div>
          </div>
          <div class="col-md-4 col-sm-12 col-12">
            <div class="contact-box-info-4">
              <i class="icon-pin"></i>
              <h4>{{ contacts[1].name }}</h4>
              <p v-html="contacts[1].description"></p>
              <h5>{{ contacts[1].value }}</h5>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section-block grey-bg">
      <div class="container">
        <div class="section-heading text-center">
          <h3 class="semi-bold font-size-30">Laissez-nous un message</h3>
          <div class="section-heading-line line-thin"></div>
          <!-- <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt<br>ut
                        labore et dolore magna aliqua. Ut enim ad minim veniam.</p> -->
        </div>
        <form class="primary-form-2 mt-45" @submit.prevent="submitContactForm">
          <div class="row">
            <div class="col-md-10 col-sm-12 col-12 offset-md-1">
              <div class="row">
                <div class="col-md-12" v-if="formIsSubmit == true">
                  <div class="alert alert-info text-center">
                    <p>
                      Envoi du message en cours ...
                    </p>
                  </div>
                </div>
                <div class="col-md-12" v-if="formIsSuccess == true">
                  <div class="alert alert-success text-center">
                    <p>
                      Message envoyé avec succès !
                    </p>
                  </div>
                </div>
                <div class="col-md-12">
                  <input
                    type="text"
                    name="name"
                    placeholder="Nom complet *"
                    v-model="contactForm.name"
                    required
                    :disabled="formIsSubmit == true"
                  />
                </div>
                <div class="col-md-6 col-sm-6 col-xs-12">
                  <the-mask
                    mask="+### ## ## ## ##"
                    type="text"
                    :masked="true"
                    placeholder="Numéro de téléphone *"
                    v-model="contactForm.phoneNumbers"
                    required
                    :disabled="formIsSubmit == true"
                  ></the-mask>
                  <!-- <input type="text" name="phone_numbers" placeholder="Numéro de téléphone *" v-model="contactForm.phoneNumbers" required :disabled="formIsSubmit == true"> -->
                </div>
                <div class="col-md-6 col-sm-6 col-xs-12">
                  <input
                    type="text"
                    name="email"
                    placeholder="Adresse email"
                    v-model="contactForm.emailAddress"
                    :disabled="formIsSubmit == true"
                  />
                </div>
                <div class="col-md-12">
                  <input
                    type="text"
                    name="subject"
                    placeholder="Sujet *"
                    v-model="contactForm.subject"
                    required
                    :disabled="formIsSubmit == true"
                  />
                </div>
                <div class="col-md-12">
                  <textarea
                    name="message"
                    placeholder="Message *"
                    v-model="contactForm.content"
                    required
                    :disabled="formIsSubmit == true"
                  ></textarea>
                </div>
                <div class="col-md-12">
                  <vue-recaptcha
                    sitekey="6Ld-MfwUAAAAANUPUTMuKH6lv7plizKiRdqdt2Ok"
                    :loadRecaptchaScript="true"
                  >
                    <button
                      type="submit"
                      class="button-md button-primary full-width"
                      :disabled="formIsSubmit == true"
                    >
                      Envoyer
                    </button>
                  </vue-recaptcha>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div id="map">
      <iframe
        class="full-width"
        height="450"
        frameborder="0"
        style="border:0"
        allowfullscreen
        src="https://www.google.com/maps/embed/v1/place?q=place_id:EjZMIDE1NSAtIFZvaWUgZGUgbGEgN2UgVHJhbmNoZSwgQWJpZGphbiwgQ8O0dGUgZCdJdm9pcmUiLiosChQKEglFZ8RPp5TBDxGpRdbbs_VwchIUChIJIZGVEVPqwQ8RpiGS4dwN5z8&key=AIzaSyCMAqXG-6h7oltK5NmMRw2DzfuEEvS2VNs"
      >
      </iframe>
    </div>
  </div>
</template>

<script>
import { BASE_URL, API_PREFIX, API_VERSION } from "../../config/urls";
import VueRecaptcha from "vue-recaptcha";

export default {
  name: "ContactUs",
  components: { VueRecaptcha },
  data() {
    return {
      contacts: null,
      contactForm: {
        name: null,
        phoneNumbers: null,
        emailAddress: null,
        subject: null,
        content: null
      },
      formIsSubmit: null,
      formIsSuccess: null
    };
  },
  mounted() {
    this.getContacts();
  },
  methods: {
    getContacts() {
      let url = BASE_URL + API_PREFIX + API_VERSION + "/infos";
      this.$http
        .get(url)
        .then(response => {
          this.contacts = response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    submitContactForm() {
      alert("Okay");
      //   this.formIsSubmit = true
      //   let url = BASE_URL + API_PREFIX + API_VERSION + '/messages'
      //   this.$http.post(url, this.contactForm)
      //     .then((response) => {
      //       this.formIsSubmit = false
      //       this.formIsSuccess = true
      //       this.contactForm = {
      //         name: null,
      //         phoneNumbers: null,
      //         emailAddress: null,
      //         subject: null,
      //         content: null
      //       }
      //     })
      //     .catch((error) => {
      //       console.log(error.response.data)
      //       this.formIsSubmit = false
      //     })
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/ContactUs.vue